import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Table } from 'reactstrap';
import { setSelectedBuildingAction } from '../../../actions/instances/buildings';
import './BuildingsList.scss';

const BuildingsList = ({
  buildings,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  return (
    <div className="row mt-5 mb-5">
      <h6>Buildings</h6>
      <br />
      <Table responsive striped hover>
        <thead>
          <tr>
            <td />
            <td>Building</td>
            <td>Dynasty</td>
          </tr>
        </thead>
        <tbody>
          {buildings && buildings.length > 0 ? (
            buildings.map(building => (
              <tr>
                <td>
                  {building.images.length > 0 ? (
                    <img alt={building.name} src={building.images[0].url} className="img-fluid" height={50} width={50} />
                  ) : (
                    <img alt={building.name} src="/images/default.jpg" className="img-fluid" height={50} width={50} />
                  )}
                </td>
                {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
                <td
                  onClick={() => {
                    dispatch(setSelectedBuildingAction(building));
                    history.push('/buildings/view');
                    window.scrollTo(0, 0);
                  }}
                >
                  {`${building.name} #${building.number}`}
                </td>
                <td>{`${building.dynasty.name} [${building.dynasty.code}]`}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={3} className="text-center">No buildings found for this instance.</td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

BuildingsList.propTypes = {
  buildings: PropTypes.array.isRequired,
};

BuildingsList.defaultProps = {

};

export default BuildingsList;
